export default "__VITE_ASSET__ScxZbALg__"